import PropTypes from 'prop-types'
import { useEffect } from 'react'
import Preview from 'features/creative/preview/Preview'
import SelectBox from 'components/form/SelectBox'
import { useDispatch, useSelector } from 'react-redux'
import {
  areaCodes,
  reset,
  setAreaCode,
  setExchange,
  setLineNumber,
} from 'features/creative/add/asset/phoneNumberSlice'
import TextInput from 'components/form/TextInput'
import ErrorText from 'components/form/ErrorText'
import { removeNumber } from 'utils'
import Button from 'components/form/Button'
import { inactiveAsset } from 'features/creative/add/build/buildCreativeSlice'

const PhoneNumber = ({ disabled, errors }) => {
  const dispatch = useDispatch()
  const { areaCode, exchange, lineNumber } = useSelector(
    state => state.creative.assets.phoneNumber
  )

  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )

  const onChangeAreaCode = v => dispatch(setAreaCode(v))
  const onChangeExchange = v => dispatch(setExchange(removeNumber(v)))
  const onChangeLineNumber = v => dispatch(setLineNumber(removeNumber(v)))

  return (
    <div className="cont_material">
      <div className="group_material">
        <div className="box_material">
          <strong className="subtit_subject2">
            버튼형 &gt; 전화번호
            <Button
              size="small"
              disabled={disabled}
              onClick={() => {
                dispatch(inactiveAsset('phoneNumber'))
              }}>
              삭제
            </Button>
          </strong>
          <div className="inner_material">
            <div className="material_item">
              <div className="tit_itemwrap">
                <strong className="tit_item">전화번호</strong>
              </div>
              <div className="desc_item">
                <div className="tel_row">
                  <SelectBox
                    value={areaCode}
                    onValueChange={onChangeAreaCode}
                    disabled={disabled}
                    noBlurOnDefault
                    error={errors?.areaCode}>
                    {areaCodes.map(code => (
                      <SelectBox.Item key={code}>{code}</SelectBox.Item>
                    ))}
                  </SelectBox>
                  <span className="txt_bar">-</span>
                  <TextInput
                    placeholder="0000"
                    value={exchange}
                    onValueChange={onChangeExchange}
                    maxLength={4}
                    hideLength
                    disabled={disabled}
                    error={errors?.exchange}
                  />
                  <span className="txt_bar">-</span>
                  <TextInput
                    placeholder="0000"
                    value={lineNumber}
                    onValueChange={onChangeLineNumber}
                    maxLength={4}
                    hideLength
                    disabled={disabled}
                    error={errors?.lineNumber}
                  />
                </div>
                <ErrorText
                  error={
                    errors?.areaCode || errors?.exchange || errors?.lineNumber
                  }
                />
                <ul className="list_guide">
                  <li>전화번호는 사용자에게 노출되는 정보입니다.</li>
                  <li>개인 휴대폰 번호가 포함되지 않도록 유의해 주세요.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Preview type="PHONE_NUMBER" />
      </div>
    </div>
  )
}

export default PhoneNumber

PhoneNumber.propTypes = {
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    areaCode: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    exchange: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    lineNumber: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }),
}
